import { defineComponent as a, computed as o, createElementBlock as r, openBlock as l, normalizeStyle as p, normalizeClass as n, createVNode as d } from "vue";
import m from "./TruncatedText.js";
/* empty css                                                                  */
import { _ as u } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const c = /* @__PURE__ */ a({
  __name: "TessText",
  props: {
    text: {},
    size: { default: "p" },
    weight: { default: "regular" },
    width: { default: "100%" },
    tooltipTheme: { default: "arbo" },
    showTooltip: { type: Boolean, default: !0 }
  },
  setup(i) {
    const e = i, t = o(() => {
      if (e.size && typeof e.size == "number")
        return `${e.size}px`;
    }), s = o(() => e.width && typeof e.width == "number" ? `${e.width}px` : e.width || "100%");
    return (h, f) => (l(), r("div", {
      class: n(["tess-text", [e.size, t.value ? "size-dynamic" : "", e.weight]]),
      style: p({ maxWidth: s.value, "--dynamic-size": t.value })
    }, [
      d(m, {
        value: e.text,
        "show-tooltip": e.showTooltip,
        "max-width": e.width,
        tooltipTheme: e.tooltipTheme
      }, null, 8, ["value", "show-tooltip", "max-width", "tooltipTheme"])
    ], 6));
  }
}), z = /* @__PURE__ */ u(c, [["__scopeId", "data-v-509d75bb"]]);
export {
  z as default
};
